import { baseApi } from "../../../api/baseApi.js";
import { prepareQueryParams } from "../../../helpers/index.js";

export const contactApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    contact: build.mutation({
      query: (payload) => {
        return {
          url: "/contactus",
          method: "POST",
          body: {
            ...prepareQueryParams(),
            ...payload,
          },
        };
      },
    }),
  }),
});

export const { useContactMutation } = contactApi;
